import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {
  private localeSubject = new BehaviorSubject<string>('en-US'); // Default locale
  locale$ = this.localeSubject.asObservable();

  constructor(private translate: TranslateService) {
    translate.onLangChange.subscribe((event) => {
      this.localeSubject.next(event.lang);
    })
  }

  setLanguages(langs: string[]){
    if(langs.length > 0){
      this.translate.addLangs(langs);
    }
  }

  get locale() {
    return this.localeSubject.value;
  }

  setLocale(lang: string) {
    this.localeSubject.next(lang);
    this.translate.use(lang);
  }
}
